import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import { CreditPolicyRow } from '../models/credit-policy-operation.model';

export interface CreditPolicyListFilter {
  page: number;
  pageSize: number;
  search?: string;
  sortField?: string;
  sortDirection?: string;
}

export interface CreditPolicyListSummary {
  count: number;
  totalLimit: number;
  totalUsed: number;
  totalAvailable: number;
}

export interface CreditPolicyListResult {
  items: CreditPolicyRow[];
  total: number;
  summary: CreditPolicyListSummary;
}

export const EMPTY_CREDIT_POLICY_SUMMARY: CreditPolicyListSummary = {
  count: 0,
  totalLimit: 0,
  totalUsed: 0,
  totalAvailable: 0,
};

@Injectable({ providedIn: 'root' })
export class CreditPolicyReadService {
  private readonly baseUrl = `${environment.apiUrl}/api/v2/credit-policies`;

  constructor(private http: HttpClient) { }

  list(filter: CreditPolicyListFilter): Promise<CreditPolicyListResult> {
    const fallback = 'No se pudo cargar la lista de pólizas de crédito';
    return firstValueFrom(this.http.post<any>(`${this.baseUrl}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
          summary: response.summary || { ...EMPTY_CREDIT_POLICY_SUMMARY },
        };
      });
  }
}
